


























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { LoadingService } from '@/services/loadingService';
import TorreControlInstance from '@/pantallas/TorreControl/comunes/Instances';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
import { Validator } from 'vee-validate';
import { ControlPatentesInterfaces } from '@/pantallas/TorreControl/ControlPatentes/controlPatentesInterfaces';
import { configService } from '@/pantallas/TorreControl/ControlConfiguracion/configService';

@Component({
  name: 'Alertas',
  components: {
    FormFieldsContainer,
  },
})
export default class Alertas extends Vue {
  clientId: string;
  isFormValid: boolean = true;
  email: string = '';
  email2: string = '';
  emailsError: string = '';
  activeAlerts: boolean = false;
  activeAlerts2: boolean = false;
  loadingService = new LoadingService();
  ConfigService = new configService();
  $snotify: any;
  hint2: string =
    'Al activar se enviará un email con los vehículos en uso fuera de horario.';
  hint: string =
    'Al activar se enviará un email con los vehículos y fallas que están ocurriendo.';

  t_desde: string = '';
  t_hasta: string = '';

  created() {
    let self = this;
    Validator.extend('emailValidate', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || `* ${self.emailsError}`;
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: self.validateEmail(value),
            data: self.validateEmail(value)
              ? undefined
              : { message: `* ${self.emailsError}` },
          });
        });
      },
    });
    Validator.extend('emailValidate2', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || `* ${self.emailsError}`;
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: self.validateEmail2(value),
            data: self.validateEmail2(value)
              ? undefined
              : { message: `* ${self.emailsError}` },
          });
        });
      },
    });
    this.clientId = localStorage.getItem('clienteDefecto');
    this.getEmail();
  }

  cleanInput() {
    if (!this.activeAlerts) {
      this.email = '';
    }
  }

  cleanInput2() {
    if (!this.activeAlerts2) {
      this.email2 = '';
      this.t_hasta = '';
      this.t_desde = '';
    }
  }

  async handleClick() {
    let resultadoValidacion = await this.$validator.validateAll();
    if (!this.activeAlerts) {
      resultadoValidacion = true;
    }
    // const resultadoValidacion = await this.$validator.validateAll();
    let data_no_autorizado = {
      active: this.activeAlerts2,
      email: this.email2,
      desde: this.t_desde,
      hasta: this.t_hasta,
    };
    console.log(data_no_autorizado);
    if (resultadoValidacion) {
      const axiosResponse: AxiosResponse<
        MSResponse<ControlPatentesInterfaces>
      > = await this.ConfigService.saveEmailAlerts(
        this.clientId,
        this.email,
        this.activeAlerts,
        data_no_autorizado
      );
      const msResponse: any = axiosResponse.data;
      if (msResponse.CODIGO_RESPUESTA == '1') {
        this.$snotify.success(msResponse.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      } else {
        this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  async getEmail() {
    const axiosResponse: AxiosResponse<
      MSResponse<ControlPatentesInterfaces>
    > = await this.ConfigService.getEmailAlerts(this.clientId);
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.email = msResponse.email;
      this.activeAlerts = msResponse.active_alerts;
      this.activeAlerts2 = msResponse.data_no_autorizado.active;
      this.email2 = msResponse.data_no_autorizado.email;
      this.t_desde = msResponse.data_no_autorizado.desde;
      this.t_hasta = msResponse.data_no_autorizado.hasta;
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
  }

  validateEmail(emails: string) {
    if (this.email == '') {
      return false;
    }
    let listaCorreos = emails.split(';');
    for (var correo of listaCorreos) {
      if (
        //eslint-disable-next-line
        !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          correo.trim()
        )
      ) {
        this.emailsError = 'Correo ' + correo + ' no es válido';
        return false;
      }
    }
    return true;
  }
  validateEmail2(emails: string) {
    if (this.email2 == '') {
      return false;
    }
    let listaCorreos = emails.split(';');
    for (var correo of listaCorreos) {
      if (
        //eslint-disable-next-line
        !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          correo.trim()
        )
      ) {
        this.emailsError = 'Correo ' + correo + ' no es válido';
        return false;
      }
    }
    return true;
  }
}
